import React, { useMemo } from "react"

import { useApp } from "../../hooks/useApp"

export const withHeaderBrand = Component => ({ name = "HeaderBrand", active, activeHover }) => {
  const {
    config: {
      app: { title },
      settings: { routes },
    },
    globalStateReducer,
  } = useApp()

  const [{ activeMenu, activeCart }] = globalStateReducer

  const url = `${routes[`HOMEPAGE`]}`

  Component.displayName = name
  return useMemo(
    () => <Component title={title} url={url} activeMenu={activeMenu} activeCart={activeCart} active={active} activeHover={activeHover} />,
    [title, url, activeMenu, activeCart, active, activeHover]
  )
}
